import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').constant('NOTIFICATION_CONFIG', {
        ENDPOINT: '/push',
        BROKER: '/topic/',
        USER_QUEUE: '/user/queue/',
        RECONNECT_TIMEOUT: 20000
    });
})();
